import type { FC, ReactNode } from "react";
import KemMedicalDisclaimer from "./KemMedicalDisclaimer";

export interface KemChatComposerSectionProps {
  showScrollToBottom: boolean;
  onScrollToNewer: () => void;
  kemIsTyping: string;
  isTranscribing?: boolean;
  /** Message limit UI, chat input, or any footer control. */
  inputArea: ReactNode;
}

const KemChatComposerSection: FC<KemChatComposerSectionProps> = ({
  showScrollToBottom,
  onScrollToNewer,
  kemIsTyping,
  isTranscribing,
  inputArea,
}) => (
  <div className="w-full min-w-0 shrink-0">
    <div aria-live="polite" className="mb-2 min-h-5 min-w-0 truncate text-xs">
      {kemIsTyping}
    </div>
    {isTranscribing && (
      <div aria-live="polite" className="mb-2 text-center text-xs text-ink-700">
        Transcribing voice...
      </div>
    )}

    <div className="relative">
      {showScrollToBottom && (
        <button
          aria-label="Scroll to bottom"
          className="absolute bottom-full left-1/2 z-10 mb-2 -translate-x-1/2 rounded-full border bg-white px-3 py-2 text-xs shadow-md hover:bg-gray-50"
          onClick={onScrollToNewer}
          type="button"
        >
          ↓ Newer
        </button>
      )}

      {inputArea}
    </div>

    <KemMedicalDisclaimer />
  </div>
);

export default KemChatComposerSection;
